<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col
        xl="4"
        md="6"
      >
        <UserCard />
      </b-col>
      <b-col
        xl="8"
        md="6"
      >
        <DepositByAccountType />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        xl="12"
        md="12"
      >
        <LoanPortfolioSummary />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col lg="5">
        <b-row>
          <b-col
            lg="7"
            md="7"
            cols="6"
          >
            <PendingLoanRequest />
          </b-col>
          <b-col
            lg="5"
            md="5"
            cols="6"
          >
            <NPLRatio />
          </b-col>
        </b-row>
        <RecentActivities />
      </b-col>

      <b-col lg="7">
        <CustomerGrowthAnalytics />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { useActions } from 'vuex-composition-helpers'
import { onMounted } from '@vue/composition-api'
import UserCard from './UserCard.vue'
import LoanPortfolioSummary from './LoanPortfolioSummary.vue'
// import PerformanceReport from './PerformanceReport.vue'
import PendingLoanRequest from './PendingLoanRequest.vue'
import CustomerGrowthAnalytics from './CustomerGrowthAnalytics.vue'
import NPLRatio from './NPLRatio.vue'
import DepositByAccountType from './DepositByAccountType.vue'
import RecentActivities from './RecentActivities.vue'
import { dashboardPermissions } from '../../../helpers/permissions'

export default {
  components: {
    BRow,
    BCol,

    UserCard,
    LoanPortfolioSummary,
    // PerformanceReport,
    RecentActivities,
    CustomerGrowthAnalytics,
    PendingLoanRequest,
    NPLRatio,
    DepositByAccountType,
  },
  setup() {
    const {
      getTillAccountList,
      getVaultAccountList,
      getBranches,
      getBanks,
      getIncomeGLAccount,
      getIncomeGLByParentCategory,
      getStationaryAccount,
      getCurrentFinancialDate,
      getCorporateInformation,
    } = useActions({
      getTillAccountList: 'operations/getTillAccountList',
      getVaultAccountList: 'operations/getVaultAccountList',
      getBranches: 'operations/getAllBranches',
      getBanks: 'operations/getBanks',
      getIncomeGLAccount: 'account/getIncomeGLAccount',
      getIncomeGLByParentCategory: 'account/getIncomeGLByParentCategory',
      getStationaryAccount: 'account/getStationaryAccount',
      getCurrentFinancialDate: 'operations/getCurrentFinancialDate',
      getCorporateInformation: 'operations/getCorporateInformationList',
    })

    const fetchData = async () => {
      await getCorporateInformation({ permission: dashboardPermissions.VIEW_BASIC_DASHBOARD })
      await getVaultAccountList({
        search: '',
        page: 0,
        limit: 1000,
        permission: 'VIEW_BASIC_DASHBOARD',
      })
      await getTillAccountList({
        search: '',
        page: 0,
        limit: 1000,
        permission: 'VIEW_BASIC_DASHBOARD',
      })
      await getBanks({ permission: 'VIEW_BASIC_DASHBOARD' })
      await getCurrentFinancialDate({ permission: 'VIEW_BASIC_DASHBOARD' })
      await getBranches({
        search: '',
        page: 0,
        limit: 0,
        permission: 'VIEW_BASIC_DASHBOARD',
      })
      await getIncomeGLAccount({ permission: 'VIEW_BASIC_DASHBOARD' })
      await getIncomeGLByParentCategory({ permission: 'VIEW_BASIC_DASHBOARD' })
      await getStationaryAccount({ permission: 'VIEW_BASIC_DASHBOARD' })
    }
    onMounted(async () => {
      await fetchData()
    })
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
